/** Column keys left-to-right — length matches `colSpan` for empty rows (keep aligned with table JSX). */
export const PAYMENT_FILE_ROW_NUMBER_COLUMN_KEYS = ['row_number'] as const;

export const PAYMENT_FILE_CORE_COLUMN_KEYS = [
  'id',
  'external_reference',
  'payee',
  'payment_method',
  'amount',
  'status',
] as const;

export const PAYMENT_FILE_REASON_COLUMN_KEYS = ['reason'] as const;

/** Full payment-file details grid: file row #, core columns, processing reason. */
export const PAYMENT_FILE_DETAILS_TABLE_COL_SPAN =
  PAYMENT_FILE_ROW_NUMBER_COLUMN_KEYS.length +
  PAYMENT_FILE_CORE_COLUMN_KEYS.length +
  PAYMENT_FILE_REASON_COLUMN_KEYS.length;
